<!-- header.component.html -->

@if (type === 'hero') {
    <!-- Navbar -->
  <div
    class="fixed inset-x-0 top-0 flex items-center justify-between px-[3rem] lg:px-[7rem] py-0 lg:pt-3 bg-zestWhite z-50"
  >
    <!-- Logo -->
    <div class="text-zestBlack flex space-x-2 items-center">
      <div *ngIf="!imageLink">
        <ngx-avatars
          [name]="displayName"
          initialsSize="0"
          cornerRadius="4"
          [round]="false"
          bgColor="inherit"
          fgColor="black"
          size="60"
        ></ngx-avatars>
      </div>
      <img
        *ngIf="imageLink"
        [src]="imageLink"
        alt="Logo"
        class="w-12 h-12 object-cover mr-2"
      />
      <!-- Filter & Search Input -->
      <div
        class="hidden md:flex items-center bg-zestNeutral-200 rounded-lg p-2 w-[400px] md:w-[450px] lg:w-[555px] h-12"
      >
        <div class="relative">
          <mat-select
            [(ngModel)]="selectedOption"
            (selectionChange)="onFilterWithPrice($event)"
            class="store-filter-select text-sm lg:text-base text-black font-medium pr-6"
            aria-label="Filter products"
          >
            @for (option of options; track option) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
            }
          </mat-select>

        </div>
        <div class=" h-6 "></div>
        <div class="relative w-3/4 xl:w-fit h-9">
          <input
            type="text"
            (keyup.enter)="onSearchTermChange($event)"
            placeholder="Search by product name"
            class="w-full text-zestTertiary-500 text-sm sm:pr-5 border-hidden mr-3 focus:border-hidden focus:ring-0 sm:pl-4 mt-[-2px] rounded xl:px-4 font-mont lg:text-base xl:w-[377px] bg-zestNeutral-200"
            #searchInput
          />
          <button (click)="onSearchIconClick(searchInput.value)">
            <img
              src="../../../assets/svg/Search.svg"
              alt="search"
              class="absolute w-4 h-4 right-1 bottom-[11px]"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- cart length -->
    <div>
      <div
        class="flex items-center rounded-[8px] p-2 bg-zestWhite"
        [routerLink]="['/stores', bizName, 'cart']"
      >
        <img
          class="mr-2 md:mr-0"
          src="../../../assets/svg/Buy.svg"
          alt="cart"
        />
        <p
          class="block text-xs lg:hidden pl-[6px] text-zestWhite bg-zestGreen rounded py-[2px] px-2"
        >
          {{ store.getCartLenght() }}
        </p>
        <p
          class="px-2 font-mont text-zestBlack font-medium text-sm leading-6 cursor-pointer hidden lg:block"
        >
          My Cart
          <span class="text-zestWhite bg-zestGreen rounded py-1 px-2">
            {{ store.getCartLenght() }}
          </span>
        </p>
      </div>
    </div>
  </div>

  <!-- Banner & Logo Section  -->
  <div class="relative px-0 lg:px-[60px] mt-0 lg:mt-[88px] h-[271px]">
    <img
      *ngIf="!bannerLink"
      src="../../assets/images/banner.png"
      alt="Banner Image"
      class="w-full h-full object-cover rounded-b-xl"
    />
    <img
      *ngIf="bannerLink"
      [src]="bannerLink"
      alt="Banner Image"
      class="w-full h-full object-cover"
    />

    <div
      class="logo-div cursor-pointer absolute bottom-[-45px] lg:bottom-[-75px] left-4 md:left-16 lg:left-[115px] w-[100px] h-[100px] md:w-[120px] md:h-[120px] lg:w-[150px] lg:h-[150px] flex items-center justify-center bg-ZTN-200 border-4 border-white rounded-[100%]"
      [routerLink]="['/stores', bizName]"
    >
      <div>
        <div *ngIf="!imageLink">
          <ngx-avatars
            [name]="displayName"
            initialsSize="0"
            cornerRadius="8"
            [round]="false"
            bgColor="inherit"
            fgColor=""
            size="160"
          ></ngx-avatars>
        </div>
      </div>
      <img
        *ngIf="imageLink"
        [src]="imageLink"
        alt="Logo"
        class="w-full h-full object-cover"
      />
    </div>
    <h1
      class="absolute bottom-[-33px] left-[7.5rem] md:left-[13rem] lg:left-[18rem] text-zestBlack text-sm md:text-[32px] font-semibold whitespace-nowrap"
    >
      {{ displayName }}
    </h1>
  </div>

} @else {
  <!-- DEFAULT HEADER -->
    <header
    class="px-4 flex justify-between sticky top-0 z-10 w-full bg-white shadow-sm items-center lg:px-40 h-20"
  >
    <div
      class="flex items-center cursor-pointer"
      [routerLink]="['/stores', bizName]"
    >
      <ngx-avatars
        [name]="displayName"
        initialsSize="0"
        cornerRadius="4"
        [round]="false"
        bgColor="#0D0F11"
        fgColor="#ffffff"
        size="40"
      >
      </ngx-avatars>
      <h1
        class="pl-[10px] text-sm leading-4 text-zestBlack font-semibold lg:text-xl lg:leading-8 font-mont"
      >
        {{ displayName }}
      </h1>
    </div>
    <div
      *ngIf="storeName?.active"
      class="flex flex-col-reverse items-end md:flex md:flex-row md:items-center"
    >
      <div
        class="flex items-center pl-5"
        [routerLink]="['/stores', bizName, 'cart']"
      >
        <img src="../../../assets/svg/Buy.svg" alt="cart" />
        <p
          class="block text-xs lg:hidden pl-[6px] text-zestWhite bg-zestGreen rounded py-[2px] px-2"
        >
          {{ store.getCartLenght() }}
        </p>
        <h2
          class="px-2 font-mont text-zestBlack font-semibold text-sm leading-6 cursor-pointer hidden lg:block"
        >
          My Cart
          <span
            class="pl-[6px] text-zestWhite bg-zestGreen rounded py-1 px-2"
            >{{ store.getCartLenght() }}</span
          >
        </h2>
      </div>
    </div>
  </header>
}
